@if (!viewMode) {
  <div   [class.file-upload-with-border]="field.extendedControl" [class.p-1]="field.extendedControl">
    <div class="mb-2"  [ngClass]="{ 'has-file': uploader?.queue?.length > 0 }">
      @if (field.extendedControl) {
        <div class="d-flex flex-column align-items-center p_0 w-100 h-100"
          [ngClass]="{'file-over': hasBaseDropZoneOver}"
          ng2FileDrop [uploader]="uploader"
          (click)="fileInput.click()"
          role="button">
          <input class="d-none" type="file" ng2FileSelect [uploader]="uploader" multiple style="opacity:0; width:0" #fileInput/>
          <ng-container >
            <i class="fa fa-cloud-upload"></i> <span>{{'Upload Files' | translate}}</span>
            <!--                <div class="d-inline-block" *ngIf ="extensionArray && extensionArray.length" >(<span>{{'Allowed Mimes:' | translate}}</span><span class="text-break">{{extensionArray.toString()}}</span> )</div>-->
          </ng-container>
        </div>
      } @else {
        @if (!field.queueLimit || uploader?.queue?.length < field.queueLimit || !field.extendedControl) {
          <label role="button" class="btn custom-input-btn" translate >
            <input type="file" ng2FileSelect [uploader]="uploader" multiple style="opacity:0; width:0" />
            <i class="fa fa-cloud-upload"></i> {{'Upload Files' | translate}}
            @if (extensionArray && extensionArray.length) {
              <div class="d-inline-block" >(<span>{{'Allowed Mimes:' | translate}}</span><span class="text-break">{{extensionArray.toString()}}</span> )</div>
            }
          </label>
        }
      }
    </div>
    <!-- TODO update the preview for multiple images -->
    @if (field.value && !uploader?.queue?.length && field.showGridPreview) {
      <div>
        <mat-card class="file-card position-relative">
          <button type="button" class="remove-btn btn btn-light position-absolute m-2" style="top: 0; right: 0; z-index: 10;"
            (click)="removeFile()">
            <i class="far fa-trash-alt"></i>
          </button>
          <img mat-card-image [src]="field.value + (field.disableCache ? '?' + now : '')" class="w-100" >
        </mat-card>
      </div>
    }
    @if (uploader?.queue?.length) {
      <div class="">
        @if (!field.queueLimit || field.queueLimit > 1) {
          <p><span translate>Queue length:</span><span>{{ uploader?.queue?.length }}</span> </p>
        }
        @if (!field.showGridPreview) {
          <table class="table">
            <thead>
              <tr>
                <th width="50%" translate>Name</th>
                <th translate>Size</th>
                <th translate>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (item of uploader.queue; track item) {
                <tr>
                  <td><strong>{{ item?.file?.name }}</strong></td>
                  @if (uploader.options.isHTML5) {
                    <td nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                  }
                  <td nowrap>
                    <button type="button" class="btn btn-xs"
                      (click)="removeFile(item)">
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          @for (item of uploader.queue; track item) {
            <mat-card class="file-card position-relative" >
              <button type="button" class="remove-btn btn btn-light position-absolute m-2" style="top: 0; right: 0; z-index: 10;"
                (click)="removeFile(item)">
                <i class="far fa-trash-alt"></i>
              </button>
              <img mat-card-image [src]="item['previewSrc']"  class="w-100">
              <mat-card-content>
                <p>{{ item?.file?.name }}</p>
              </mat-card-content>
            </mat-card>
          }
        }
      </div>
    }
    <span  class="app-red-text error error-msg" translate>{{errorMessage}}</span>
  </div>
} @else {
  @if (media) {
    <a [href]="restUrlsConf.appURL + '/public/download/media/' + media['id'] + '.json'">{{ media['filename']}}</a>
  }
}


